export default "__VITE_PUBLIC_ASSET__6857f0ef__"